import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../../components/Hyperlink';
import { UserContext } from '../../../../user/UserContext';
import { DecisionUploadContext } from '../DecisionUploadContext';
import {
  DecisionUploadWarningContainer,
  DecisionUploadWarningTitle,
  DecisionUploadWarningIcon,
} from '../components/DecisionUploadWarningComponents';

export const DecisionUploadRestriction: FC = () => {
  const { plansAllowed } = useContext(DecisionUploadContext);
  const { currentUser } = useContext(UserContext);

  const warnNonPayingUser =
    !currentUser ||
    (!plansAllowed.includes(currentUser.plan) && !currentUser.verified);
  if (!warnNonPayingUser) return null;

  return (
    <DecisionUploadWarningContainer>
      <DecisionUploadWarningIcon />
      <DecisionUploadWarningTitle>
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadRestriction.tsx/1" />{' '}
        <Hyperlink href="/tarifs" source="upload_decision">
          <FormattedMessage id="upload/decision-upload/components/DecisionUploadRestriction.tsx/2" />
        </Hyperlink>
      </DecisionUploadWarningTitle>
    </DecisionUploadWarningContainer>
  );
};
